import { inject, Injectable, signal } from '@angular/core';
import { StorageService } from '@core/services/storages.service';
import { TrunkBaseConfigurationService } from '@core/services/trunk-base-configuration/trunk-base-configuration.service';
import { AIConfigurationStore } from '@modules/configuration-ia/services/store/ai-configuration.store';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SharedStateSelectedFiltersServiceNew {
  protected readonly aiConfigStore = inject(AIConfigurationStore);
  private readonly trunkBaseConfigurationService = inject(TrunkBaseConfigurationService);
  private userInfo?: any;
  public isBrandSelected: boolean = false;
  public isDistributorSelected: boolean = false;
  public isCatalogsCharged: boolean = true;
  public idSTELLANTIS: string =  environment.STELLANTIS.id;
  public stellantisUser: string = this.trunkBaseConfigurationService.CIAStellantisMultiBrand ? '0' : environment.STELLANTIS.id;
  constructor(
    private storageService: StorageService,
  ) { }
  //Marca
  private idBrandSelected = signal<string | null>(null);
  private brandSelectedText = signal<string | null>(null);
  //Distribuidor
  private idDistributorSelected = signal<string | null>(null);
  //Segmentacion
  private idSegmentationSelected = signal<string | null>(null);
  private segmentationSelectedText = signal<string | null>(null);
  //Submarca
  private idBaseBrandSelected = signal<string | null>(null);
  private baseBrandSelectedText = signal<string | null>(null);
  //Datos Base
  private idBrandBase = signal<string | null>(null);
  private idDistributorBase = signal<string | null>(null);
  private idDistributorBDC = signal<string | null>(null);
  private idBaseDeDatosPlayground = signal<string | null>(null);
  private isSegmentationActive = signal<boolean>(false);
  private isMultibrandActive = signal<boolean>(false);

  public get $idBrandSelected(): string | null { return this.idBrandSelected(); }
  public get $brandSelectedText(): string | null { return this.brandSelectedText(); }
  public get $idDistributorSelected(): string | null { return this.idDistributorSelected(); }
  public get $idSegmentationSelected(): string | null { return this.idSegmentationSelected(); }
  public get $segmentationSelectedText(): string | null { return this.segmentationSelectedText(); }
  public get $idBaseBrandSelected(): string | null { return this.idBaseBrandSelected(); }
  public get $baseBrandSelectedText(): string | null { return this.baseBrandSelectedText(); }
  public get $idBrandBase(): string | null { return this.idBrandBase(); }
  public get $idDistributorBase(): string | null { return this.idDistributorBase(); }
  public get $idDistributorBDC(): string | null { return this.idDistributorBDC(); }
  public get $isSegmentationActive(): boolean { return this.isSegmentationActive(); }
  public get $isMultibrandActive(): boolean { return this.isMultibrandActive(); }
  public get $idBaseDeDatosPlayground(): string | null { return this.idBaseDeDatosPlayground(); }

  public get ALL_SELECTOR_ID(): string {
    return '-1';
  }
  public get STELLANTIS_ID(): string {
    if (this.trunkBaseConfigurationService.CIAStellantisMultiBrand) {
      return '0';
    }
    return environment.STELLANTIS.id;
  }
  public get ADISTEM_ID(): string {
    if(this.trunkBaseConfigurationService.CIAADISTEMMultiBrand){
      return '0';
    }
    return environment.ADISTEMENV;
  }
  public get STELLANTIS_TEXT(): string {
    return environment.STELLANTIS.name;
  }

  public setIdBrandSelected(value: string | null) { this.idBrandSelected.set(value); }
  public setIdBrandBase(value: string | null) { this.idBrandBase.set(value); }
  public setBrandSelectedText(value: string | null) { this.brandSelectedText.set(value); }
  public setIdDistributorSelected(value: string | null) { this.idDistributorSelected.set(value); }
  public setIdDistributorBase(value: string | null) { this.idDistributorBase.set(value); }
  public setIdSegmentationSelected(value: string | null) { this.idSegmentationSelected.set(value); }
  public setSegmentationSelectedText(value: string | null) { this.segmentationSelectedText.set(value); }
  public setIdDistributorBDC(value: string | null) { this.idDistributorBDC.set(value); }
  public setIdBaseBrandSelected(value: string | null) { this.idBaseBrandSelected.set(value); }
  public setBaseBrandSelectedText(value: string | null) { this.baseBrandSelectedText.set(value); }
  public setIsSegmentationActive(value: boolean) { this.isSegmentationActive.set(value); }
  public setIsMultibrandActive(value: boolean) { this.isMultibrandActive.set(value); }
  public setIdBaseDeDatosPlayground(value: string | null) { this.idBaseDeDatosPlayground.set(value); }

  public setBaseInfo() {
    this.userInfo = this.storageService.getSessionStorage('userInfo')
    this.setIdBrandBase(this.userInfo.IdMarca ?? '');
    // this.setIdBrandSelected(this.userInfo.IdMarca ?? '');
    this.setIdDistributorBase(this.userInfo.IdDistribuidor ?? '');
    this.setIdDistributorSelected(this.userInfo.IdDistribuidor ?? '');
    this.setIdDistributorBDC(this.userInfo.IdDistribuidorBDC ?? '');
    this.setIdBaseBrandSelected(this.userInfo.IdMarca ?? '');
    this.setIsSegmentationActive(this.userInfo.EsMultiMarca ?? false);
    this.setIdBaseDeDatosPlayground(this.userInfo.IdBaseDeDatosPlayground ?? '');
  }
  public isCorporativeUser(): boolean {
    const idDistributor = this.$idDistributorBase ?? '';
    return idDistributor.endsWith('000');
  }
  //Valida si el usuario es de grupo stellantis
  public isSegmentationUser(): boolean {
    return this.userInfo.IdMarca === this.stellantisUser ||
      this.idBaseBrandSelected() == this.stellantisUser ||
      this.userInfo.IdMarca === this.ADISTEM_ID ||
      this.idBaseBrandSelected() == this.ADISTEM_ID;
  }
  public isSeekOpAdmin(): boolean {
    return this.userInfo.isSeekOpAdmin ?? true;
  }
  public isBDCUser(): boolean {
    return this.userInfo.EsBDC ?? false;
  }
  public isMultibrand() {
    const brandCatalog = this.aiConfigStore.catalogs().baseBrands;
    const isMultibrand = brandCatalog?.find(brand => brand.idMarca == this.idBaseBrandSelected());
    if (this.idBaseBrandSelected() == this.stellantisUser || this.idBaseBrandSelected() == this.ADISTEM_ID) {
      return false;
    } else {
      return isMultibrand?.multimarca ?? false;
    }
  }
  public cleanService() {
    this.setIdBrandBase(null);
    this.setIdBrandSelected(null);
    this.setIdDistributorBase(null);
    this.setIdDistributorSelected(null);
  }
  public getBrandInfo(): { id: string, name: string } {
    let idBrand = this.$idBaseBrandSelected ?? '';
    let brandText = this.$baseBrandSelectedText ?? '';
    if (idBrand == this.ALL_SELECTOR_ID) idBrand = '';
    return { id: idBrand, name: brandText };
  }

  public getSegmentationInfo(): { id: string, name: string } {
    const id = this.$idSegmentationSelected == '0' ? '' : this.$idSegmentationSelected ?? '';
    const name = this.$segmentationSelectedText ?? '';
    return { id, name };
  }

  public getSubbrandInfo(): { id: string, name: string } {
    const id = this.$idBrandSelected == '0' ? '' : this.$idBrandSelected ?? '';
    const name = this.$brandSelectedText ?? '';
    return { id, name };
  }
  public clearAllSelections(): void {
    // Limpia marca seleccionada
    this.setIdBrandSelected(null);
    this.setBrandSelectedText(null);

    // Limpia distribuidor seleccionado
    this.setIdDistributorSelected(null);

    // // Limpia segmentación
    this.setIdSegmentationSelected(null);
    this.setSegmentationSelectedText(null);
  }

  //flags loading
  public isLoadingSegments: boolean = false;
  public isLoadingMultibrand: boolean = false;

  // KDB - Auto y Modelo
  private infoAuto = signal<{ id: string; text: string } | null>(null);
  private infoModelo = signal<{ id: string; text: string } | null>(null);

  public get $infoAuto(): { id: string; text: string } | null { return this.infoAuto(); }
  public get $infoModelo(): { id: string; text: string } | null { return this.infoModelo(); }

  public setInfoAuto(value: { id: string; text: string } | null) { this.infoAuto.set(value); }
  public setInfoModelo(value: { id: string; text: string } | null) { this.infoModelo.set(value); }

  public clearKdbSelections(): void {
    this.setInfoAuto(null);
    this.setInfoModelo(null);
  }

  public getAutoInfo(): { id: string; text: string } {
    return this.$infoAuto ?? { id: '', text: '' };
  }

  public getModeloInfo(): { id: string; text: string } {
    return this.$infoModelo ?? { id: '', text: '' };
  }
}
